import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { ReactNode, useEffect, useRef, useState } from 'react';

interface IProps {
  triggerNode: ReactNode;
  content: ReactNode;
  wrapperClass?: string;
}

export default (props: IProps) => {
  const { triggerNode, content, wrapperClass } = props;
  const [tooltipOpen, setToolTipOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      if (triggerRef.current && !triggerRef.current.contains(event.target as Node)) {
        setToolTipOpen(false);
      }
    };

    document.addEventListener('click', clickHandler);
    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, []);
  return (
    <TooltipProvider>
      <Tooltip open={tooltipOpen}>
        <TooltipTrigger>
          <div ref={triggerRef} onClick={() => setToolTipOpen(!tooltipOpen)}>
            {triggerNode}
          </div>
        </TooltipTrigger>
        <TooltipContent className={wrapperClass}>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
